import { useEffect } from "react";
import { useCookieConsent } from "../context/CookieConsentContext";

const GA_MEASUREMENT_ID = "G-XXXXXXX"; // replace with your real GA4 ID

export default function AnalyticsLoader() {
  const { consent } = useCookieConsent();

  useEffect(() => {
    if (!consent.performance) return;
    if (document.getElementById("ga-script")) return;

    const script = document.createElement("script");
    script.id = "ga-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", GA_MEASUREMENT_ID);
    };
  }, [consent.performance]);

  return null;
}